module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), (!_vm.error) ? [_c('div', {
    staticClass: "campaign-step-format"
  }, [_c('div', {
    staticClass: "swiper-slider-container"
  }, [_c('swiper', {
    ref: "formatSwiper",
    class: {
      'not-full': _vm.postExamples.length < 4
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.postExamples), function(ex, key) {
    return _c('swiper-slide', {
      directives: [{
        name: "resize",
        rawName: "v-resize:debounce",
        value: (function (el) {
          if (key === 0) {
            _vm.calculateButtonOffset(el);
          }
        }),
        expression: "el => { if (key === 0) { calculateButtonOffset(el); } }",
        arg: "debounce"
      }],
      key: key,
      ref: "slide" + ex.type,
      refInFor: true,
      attrs: {
        "data-format": ex.type
      }
    }, [_c('div', {
      staticClass: "card-container",
      attrs: {
        "data-card": ex.type
      },
      on: {
        "click": function($event) {
          _vm.toggleFormatModal(ex, true)
        }
      }
    }, [_c('b-card', {
      class: {
        active: _vm.campaign.type === ex.type, 'normalize-header': _vm.normalize
      },
      attrs: {
        "header": _vm.formatHeader(ex)
      }
    }, [_c('div', {
      staticClass: "img",
      class: ( _obj = {
        'normalize-swiper': _vm.normalize
      }, _obj[ex.type] = ex.type, _obj )
    }, [_c('img', {
      style: ({
        width: '100%',
        height: 'auto',
        maxWidth: '300px'
      }),
      attrs: {
        "src": ex.preview
      }
    })]), _c('div', {
      staticClass: "card-description hidden-lg-up"
    }, [_vm._v(_vm._s(_vm.$t('pos.format.description.short', {
      format: ex.type,
      extraCost: ex.extra_cost || 0
    })))])])], 1)])
    var _obj;
  })), _c('div', {
    staticClass: "swiper-button-prev hidden-lg-up",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next hidden-lg-up",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 1), (_vm.creativeRefreshOptions) ? _c('div', {
    staticClass: "form-inline mb-5"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pos.format.how-many-creative-refresh')))]), _c('b-form-select', {
    staticClass: "ml-3",
    attrs: {
      "options": _vm.creativeRefreshOptions
    },
    model: {
      value: (_vm.creativeRefreshCount),
      callback: function($$v) {
        _vm.creativeRefreshCount = $$v
      },
      expression: "creativeRefreshCount"
    }
  })], 1) : _vm._e(), (_vm.showNewCreative) ? _c('div', {
    staticClass: "form-inline mb-5"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0,
      "disabled": _vm.disabledNewCreative
    },
    model: {
      value: (_vm.campaign.details.newcreative),
      callback: function($$v) {
        _vm.campaign.details.newcreative = $$v
      },
      expression: "campaign.details.newcreative"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.format.i-would-like-new-creative')))])], 1) : _vm._e(), _c('div', {
    staticClass: "confirm-container"
  }, [_c('b-button', {
    ref: "confirm",
    staticClass: "btn-confirm desktop-confirm",
    style: ({
      width: _vm.confirmWidth > 0 ? (_vm.confirmWidth + "px") : '100%',
      'margin-left': (_vm.confirmOffsetLeft + "px")
    }),
    attrs: {
      "size": "lg",
      "variant": _vm.proceed ? "success" : "cancel",
      "disabled": !_vm.proceed
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.format.proceed')))])], 1)]), _c('b-button', {
    ref: "confirm",
    staticClass: "btn-confirm mobile-confirm main-confirm format-confirm",
    style: ({
      width: _vm.confirmWidth > 0 ? (_vm.confirmWidth + "px") : '100%',
      'margin-left': (_vm.confirmOffsetLeft + "px")
    }),
    attrs: {
      "size": "lg",
      "variant": _vm.proceed ? "success" : "cancel",
      "disabled": !_vm.proceed
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.format.proceed')))])] : _vm._e(), _vm._l((_vm.postExamples), function(ex, key) {
    return _c('b-modal', {
      key: key,
      ref: "modal" + ex.type,
      refInFor: true,
      attrs: {
        "size": "lg",
        "title": _vm.$t("pos.format.modal.title"),
        "hide-footer": false,
        "hide-header": _vm.isActiveLeadPreview || _vm.isLocalOffersPreview,
        "hide-header-close": true
      }
    }, [_c('b-tabs', {
      ref: "modal" + ex.type + "tabs",
      refInFor: true,
      class: _vm.isActiveLeadPreview || _vm.isLocalOffersPreview ? '' : 'nav-tabs-hidden',
      attrs: {
        "data-format": ex.type
      },
      on: {
        "input": _vm.onTabDisplay
      }
    }, [_c('b-tab', {
      attrs: {
        "title": _vm.$t("pos.format.modal.title")
      }
    }, [_c('campaign-format-popup', {
      attrs: {
        "title": _vm.formatHeader(ex),
        "source": _vm.$t('pos.format.description.full', {
          format: ex.type,
          extraCost: ex.extra_cost || 0
        }),
        "type": _vm.getActiveConfirmButton(ex.type)
      },
      on: {
        "confirm": function($event) {
          _vm.confirm(ex)
        },
        "cancel": function($event) {
          _vm.cancel(ex)
        }
      }
    }, [_c('div', {
      staticClass: "format-swiper",
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_c('swiper', {
      ref: "modal" + ex.type + "swiper",
      refInFor: true,
      attrs: {
        "options": _vm.formatSwiperOptions
      }
    }, [_c('swiper-slide', {
      staticClass: "video-slide"
    }, [_c('video', {
      staticClass: "video-element",
      attrs: {
        "autoplay": "autoplay",
        "loop": "loop"
      },
      domProps: {
        "muted": true
      }
    }, [_c('source', {
      attrs: {
        "src": ex.video_web.path,
        "type": "video/mp4"
      }
    })])]), _c('swiper-slide', {
      staticClass: "video-slide"
    }, [_c('video', {
      staticClass: "video-element",
      attrs: {
        "autoplay": "autoplay",
        "loop": "loop"
      },
      domProps: {
        "muted": true
      }
    }, [_c('source', {
      attrs: {
        "src": ex.video_mobile.path,
        "type": "video/mp4"
      }
    })])])], 1), _c('div', {
      staticClass: "button button-desktop",
      attrs: {
        "slot": "button-prev"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.icons.getPostPreview("desktop"))
      },
      slot: "button-prev"
    }), _c('div', {
      staticClass: "button button-mobile",
      attrs: {
        "slot": "button-next"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.icons.getPostPreview("mobile"))
      },
      slot: "button-next"
    })], 1)])], 1), (_vm.isActiveLeadPreview) ? _c('b-tab', {
      attrs: {
        "title": _vm.$t("pos.format.modal.leadForm.title")
      }
    }, [_c('campaign-format-popup', {
      attrs: {
        "title": _vm.$t('pos.format.modal.leadForm.heading'),
        "source": _vm.$t('pos.format.modal.leadForm.description')
      },
      on: {
        "confirm": function($event) {
          _vm.confirm(ex)
        },
        "cancel": function($event) {
          _vm.cancel(ex)
        }
      }
    }, [_c('lead-form-preview', {
      ref: "modal" + ex.type + "leadAd",
      refInFor: true,
      attrs: {
        "slot": "left",
        "headerImage": ex.preview,
        "question": _vm.leadConfig.default_question,
        "inputFields": _vm.leadConfig.user_data
      },
      slot: "left"
    })], 1)], 1) : _vm._e(), (_vm.isLocalOffersPreview) ? _c('b-tab', {
      attrs: {
        "title": _vm.$t("pos.format.modal.offers.title")
      }
    }, [_c('campaign-format-popup', {
      attrs: {
        "title": _vm.$t('pos.format.modal.offers.heading'),
        "source": _vm.$t('pos.format.modal.offers.description')
      },
      on: {
        "confirm": function($event) {
          _vm.confirm(ex)
        },
        "cancel": function($event) {
          _vm.cancel(ex)
        }
      }
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "slot": "left",
        "src": require("@/assets/img/offer-preview.png")
      },
      slot: "left"
    })])], 1) : _vm._e()], 1)], 1)
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-283591b0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-format/CampaignFormat.vue
// module id = 918
// module chunks = 1